var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHotlineWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62 58.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eg\\xE9szs\\xE9g_hotline"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "43.3 11.46 39.64 11.46 39.64 14.69 43.3 14.69 43.3 18.34 46.53 18.34 46.53 14.69 50.18 14.69 50.18 11.46 46.53 11.46 46.53 7.8 43.3 7.8 43.3 11.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.11,52.1h0v0l4.81-8.54L39.57,35.65,33,39l.24,8A28,28,0,0,1,19,39.09a28,28,0,0,1-7.85-14.22l7.87.24,3.35-6.56L16,9.41,15.74,9,14.48,7.18,5.92,12h0A13.18,13.18,0,0,0,4.7,13.06c-7,7-3.74,21.79,7.4,32.92S38,60.42,45,53.38a11.91,11.91,0,0,0,1.09-1.28s0,0,0,0"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "31.61 30.64 38.21 24.04 29.78 24.04 29.78 1 61 1 61 24.04 45.15 24.04"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotlineWhite);
export default __webpack_public_path__ + "static/media/hotlineWhite.1e85472d35e1caa5e675490db18e3b43.svg";
export { ForwardRef as ReactComponent };